const SCROLL_ANIMATION_TRIGGER_CLASSNAME="scroll-trigger",SCROLL_ANIMATION_OFFSCREEN_CLASSNAME="scroll-trigger--offscreen",SCROLL_ZOOM_IN_TRIGGER_CLASSNAME="animate--zoom-in",SCROLL_ANIMATION_CANCEL_CLASSNAME="scroll-trigger--cancel";function onIntersection(elements,observer){elements.forEach((element,index)=>{if(element.isIntersecting){const elementTarget=element.target;elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)&&(elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME),elementTarget.hasAttribute("data-cascade")&&elementTarget.setAttribute("style",`--animation-order: ${index};`)),observer.unobserve(elementTarget)}else element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME),element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME)})}function initializeScrollAnimationTrigger(rootEl=document,isDesignModeEvent=!1){const animationTriggerElements=Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));if(animationTriggerElements.length===0)return;if(isDesignModeEvent){animationTriggerElements.forEach(element=>{element.classList.add("scroll-trigger--design-mode")});return}const observer=new IntersectionObserver(onIntersection,{rootMargin:"0px 0px -50px 0px"});animationTriggerElements.forEach(element=>observer.observe(element))}function initializeScrollZoomAnimationTrigger(){if(window.matchMedia("(prefers-reduced-motion: reduce)").matches)return;const animationTriggerElements=Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));if(animationTriggerElements.length===0)return;const scaleAmount=.2/100;animationTriggerElements.forEach(element=>{let elementIsVisible=!1;new IntersectionObserver(elements=>{elements.forEach(entry=>{elementIsVisible=entry.isIntersecting})}).observe(element),element.style.setProperty("--zoom-in-ratio",1+scaleAmount*percentageSeen(element)),window.addEventListener("scroll",throttle(()=>{elementIsVisible&&element.style.setProperty("--zoom-in-ratio",1+scaleAmount*percentageSeen(element))}),{passive:!0})})}function percentageSeen(element){const viewportHeight=window.innerHeight,scrollY=window.scrollY,elementPositionY=element.getBoundingClientRect().top+scrollY,elementHeight=element.offsetHeight;if(elementPositionY>scrollY+viewportHeight)return 0;if(elementPositionY+elementHeight<scrollY)return 100;let percentage=(scrollY+viewportHeight-elementPositionY)/((viewportHeight+elementHeight)/100);return Math.round(percentage)}window.addEventListener("DOMContentLoaded",()=>{initializeScrollAnimationTrigger(),initializeScrollZoomAnimationTrigger()}),Shopify.designMode&&(document.addEventListener("shopify:section:load",event=>initializeScrollAnimationTrigger(event.target,!0)),document.addEventListener("shopify:section:reorder",()=>initializeScrollAnimationTrigger(document,!0)));
//# sourceMappingURL=/s/files/1/0785/2893/8314/t/2/assets/animations.js.map?v=1697616162
const observer1 = new MutationObserver((mutations, obs) => {
    const overlay = document.getElementById('ageGateOverlay');
    
    if (overlay) {
        document.body.classList.add("agegate-lock");
        overlay.style.display = "block";
        obs.disconnect();
        initAgeGate();
    }
});

observer1.observe(document.documentElement, {
    childList: true,
    subtree: true
});

function initAgeGate() {
    const overlay = document.getElementById("ageGateOverlay");
    const track = document.getElementById("swipeTrack");
    const knob = document.getElementById("swipeKnob");
    const fill = document.getElementById("swipeFill");

    if (!overlay || !track || !knob) {
        setTimeout(initAgeGate, 50);
        return;
    }

    let dragging = false;
    let current = 0;
    let max = 0;

    const recalc = () => {
        const trackRect = track.getBoundingClientRect();
        const knobRect = knob.getBoundingClientRect();
        max = trackRect.width - knobRect.width;
    };

    const apply = (px) => {
        knob.style.transform = `translateX(${px}px)`;
        if (fill) fill.style.width = `${(px / (max || 1)) * 100}%`;
    };

    const reset = () => {
        current = 0;
        knob.style.transition = "transform 0.2s ease";
        if (fill) fill.style.transition = "width 0.2s ease";
        apply(0);
        setTimeout(() => {
            knob.style.transition = "";
            if (fill) fill.style.transition = "";
        }, 200);
    };

    const finish = () => {
        document.body.classList.remove('agegate-lock');
        overlay.style.display = 'none';
    };

    recalc();

    // Event Listeners
    knob.addEventListener("pointerdown", (e) => {
        dragging = true;
        knob.setPointerCapture(e.pointerId);
        recalc(); 
    });

    knob.addEventListener("pointermove", (e) => {
        if (!dragging) return;
        const trackLeft = track.getBoundingClientRect().left;
        let x = e.clientX - trackLeft - (knob.offsetWidth / 2);
        
        if (x < 0) x = 0;
        if (x > max) x = max;
        current = x;
        apply(current);
    });

    knob.addEventListener("pointerup", () => {
        dragging = false;
        if (current >= max * 0.85) { 
            finish();
        } else {
            reset();
        }
    });

    knob.addEventListener("pointercancel", reset);
    window.addEventListener("resize", recalc);
}